

































































import {Component, Mixins, Watch} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {WalletPlatform} from '@/enums/WalletPlatform'
import ConnectWalletChooseWallet from '@/components/walletConnection/ConnectWalletChooseWallet.vue'
import {ConnectWalletStep} from '@/enums/ConnectWalletStep'
import ConnectWalletNeon from '@/components/walletConnection/ConnectWalletNeon.vue'
import ConnectWalletNeoline from '@/components/walletConnection/ConnectWalletNeoline.vue'
import ConnectWalletOnegate from '@/components/walletConnection/ConnectWalletOnegate.vue'
import ConnectWalletWC from '@/components/walletConnection/ConnectWalletWC.vue'
import {$} from '@/facade'
import {TWalletNetwork} from '@/model/wallets/types/WalletNetwork'
import {NetworkNamespace} from '@/enums/NetworkNamespace'
import {BrowserHelper} from '@/helpers/BrowserHelper'
import {
  isNeoLineAvailableInBrowser,
  isNeoLineInAppBrowser,
} from '@/store/model/wallets/connection/NeoLineConnection'
import {isOneGateInAppBrowser} from '@/store/model/wallets/connection/OneGateConnection'
import {
  isWrongNeoLineNetworkError,
  wrongNeoLineNetworkDetected,
} from '@/store/model/wallets/connection/NeolineNetworkValidation'
import {
  RejectedByUser,
  isUnsupportedWalletNamespaceError,
  isWrongWalletNetworkError,
} from '@/model/wallets/types/WalletErrors'
import {siteNetwork} from '@/helpers/NetworkModeRegistry'
import {isWalletPlatformEnabled} from '@/config/WalletAvailabilityConfig'

type TOpenEventParams = {
  actionToDoAfterConnect?: () => Promise<void> | void
  networkNamespace?: NetworkNamespace
  walletImplementation?: 'n3' | 'neoX'
  network?: TWalletNetwork
}

@Component({
  components: {
    ConnectWalletWC,
    ConnectWalletNeon,
    ConnectWalletNeoline,
    ConnectWalletOnegate,
    ConnectWalletChooseWallet,
  },
  computed: {
    ConnectWalletStep() {
      return ConnectWalletStep
    },
  },
})
export default class ConnectWalletModal extends Mixins(MixinScreenSize) {
  actionToDoAfterConnect: (() => Promise<void> | void) | null = null
  modalState = ConnectWalletStep.CHOOSE_WALLET
  isWaitingConnection = false

  networkNamespace: NetworkNamespace = NetworkNamespace.n3

  network: TWalletNetwork | null = null

  resetModal() {
    this.isWaitingConnection = false
    this.networkNamespace = NetworkNamespace.n3
    this.network = null
    this.modalState = ConnectWalletStep.CHOOSE_WALLET
  }

  onReturnToChooseWallet() {
    this.isWaitingConnection = false
    this.modalState = ConnectWalletStep.CHOOSE_WALLET
  }

  async onSelectWallet(
    namespace: NetworkNamespace,
    wallet?: WalletPlatform
  ): Promise<void> {
    try {
      this.networkNamespace = namespace
      this.network = this.resolveNetworkFor(namespace)
      this.isWaitingConnection = true

      let connected = false

      if (namespace === NetworkNamespace.n3) {
        switch (wallet) {
          case WalletPlatform.NEON:
            connected = await this.connectNeonN3()
            break
          case WalletPlatform.NEOLINE:
            connected = await this.connectNeolineN3()
            break
          case WalletPlatform.ONEGATE:
            connected = await this.connectOneGateN3()
            break
          default:
            connected = await this.connectWalletConnectN3()
            break
        }
      } else if (namespace === NetworkNamespace.x) {
        switch (wallet) {
          case WalletPlatform.NEON:
            connected = await this.connectNeonX()
            break
          case WalletPlatform.NEOLINE:
            connected = await this.connectNeolineX()
            break
          case WalletPlatform.ONEGATE:
            connected = await this.connectOneGateX()
            break
          default:
            connected = await this.connectWalletConnectX()
            break
        }
      }

      if (connected) {
        $.modal.close('connectWalletModal')
      } else {
        this.isWaitingConnection = false
      }
    } catch (error) {
      console.error('[ConnectWallet]', {
        wallet,
        namespace,
        network: this.targetNetwork ?? siteNetwork(),
        error,
      })

      if (isWrongNeoLineNetworkError(error)) {
        $.toast.error(
          this.neoLineWrongNetworkMessage(namespace, error),
          '',
          false
        )
      } else if (isUnsupportedWalletNamespaceError(error)) {
        $.toast.error(this.unsupportedBlockchainMessage(namespace), '', false)
      } else if (isWrongWalletNetworkError(error)) {
        $.toast.error(this.wrongNetworkMessage(namespace), '', false)
      } else if (error !== RejectedByUser) {
        $.toast.error('system.error.walletConnectionFailed')
      }

      this.resetModal()
    }
  }

  openEvent(params?: TOpenEventParams) {
    const {
      actionToDoAfterConnect,
      networkNamespace,
      walletImplementation,
      network,
    } = params ?? {}

    this.network = network ?? null

    if (walletImplementation) {
      this.networkNamespace =
        walletImplementation === 'neoX'
          ? NetworkNamespace.x
          : NetworkNamespace.n3
    }

    if (typeof actionToDoAfterConnect !== 'undefined') {
      this.actionToDoAfterConnect = actionToDoAfterConnect
    }

    if (typeof networkNamespace !== 'undefined') {
      this.networkNamespace = networkNamespace
    }

    this.$emit('open')
  }

  async closeEvent() {
    this.resetModal()
    this.$emit('close')

    const isConnected =
      this.networkNamespace === NetworkNamespace.x
        ? !!$.walletAdapter.addressOf('neoX', this.targetNetwork)
        : !!$.walletAdapter.addressOf('n3', this.targetNetwork)

    if (this.actionToDoAfterConnect && isConnected) {
      await this.actionToDoAfterConnect()
    }
  }

  @Watch('$store.state.walletAdapter.n3.address')
  onN3AddressChange(address: string | null) {
    if (
      address &&
      this.networkNamespace === NetworkNamespace.n3 &&
      this.modalState !== ConnectWalletStep.CHOOSE_WALLET
    ) {
      $.modal.close('connectWalletModal')
    }
  }

  @Watch('$store.state.walletAdapter.neoX.address')
  onXAddressChange(address: string | null) {
    if (
      address &&
      this.networkNamespace === NetworkNamespace.x &&
      this.modalState !== ConnectWalletStep.CHOOSE_WALLET
    ) {
      $.modal.close('connectWalletModal')
    }
  }

  openNeolineDownloadPage() {
    const ua = navigator.userAgent || ''
    const isAndroid = /android/i.test(ua)
    const isIOS = /iphone|ipad|ipod/i.test(ua)

    if (this.isMobile && isAndroid) {
      window.open(
        'https://play.google.com/store/apps/details?id=com.neoline.app'
      )
      return
    }

    if (this.isMobile && isIOS) {
      window.open('https://apps.apple.com/app/neoline/id1484779135')
      return
    }

    if (this.isMobile) {
      window.open('https://neoline.io/')
      return
    }

    if (BrowserHelper.checkIfFirefox()) {
      window.open('https://addons.mozilla.org/en-US/firefox/addon/neoline/')
    } else {
      window.open(
        'https://chromewebstore.google.com/detail/neoline/cphhlgmgameodnhkjdmkpanlelnlohao?pli=1'
      )
    }
  }

  private resolveNetworkFor(
    namespace: NetworkNamespace
  ): TWalletNetwork | null {
    const walletImplementation =
      namespace === NetworkNamespace.x ? 'neoX' : 'n3'
    const available: TWalletNetwork[] = this.$store.state.walletAdapter
      .networksInUse[walletImplementation]

    return this.network && available.includes(this.network)
      ? this.network
      : null
  }

  private get targetNetwork(): TWalletNetwork | undefined {
    return this.network ?? undefined
  }

  private blockchainName(namespace: NetworkNamespace): string {
    return namespace === NetworkNamespace.x ? 'Neo X' : 'Neo N3'
  }

  private wrongNetworkMessage(namespace: NetworkNamespace): string {
    const network =
      (this.targetNetwork ?? siteNetwork()) === 'testnet'
        ? 'Testnet'
        : 'Mainnet'

    return this.$translate('system.error.wrongWalletNetwork').replace(
      '%s',
      `${this.blockchainName(namespace)} ${network}`
    )
  }

  private neoLineWrongNetworkMessage(
    namespace: NetworkNamespace,
    error: unknown
  ): string {
    const detected = wrongNeoLineNetworkDetected(error)

    if (!detected) {
      return this.$translate('system.error.wrongNeoLineNetwork')
    }

    const network =
      (this.targetNetwork ?? siteNetwork()) === 'testnet'
        ? 'Testnet'
        : 'Mainnet'

    return this.$translate('system.error.neoLineOnAnotherNetwork')
      .replace('%detected%', detected)
      .replace('%expected%', `${this.blockchainName(namespace)} ${network}`)
  }

  private unsupportedBlockchainMessage(namespace: NetworkNamespace): string {
    return this.$translate('system.error.unsupportedWalletBlockchain').replace(
      '%s',
      this.blockchainName(namespace)
    )
  }

  private async showConnectionStep(step: ConnectWalletStep) {
    this.modalState = step
    await this.$nextTick()
  }

  private async connectNeonN3(): Promise<boolean> {
    await this.showConnectionStep(ConnectWalletStep.NEON_CONNECT)
    return (
      (await $.walletAdapter.connectN3Wallet(
        WalletPlatform.NEON,
        this.targetNetwork
      )) === true
    )
  }

  private async connectNeonX(): Promise<boolean> {
    await this.showConnectionStep(ConnectWalletStep.NEON_CONNECT)
    return (
      (await $.walletAdapter.connectXWallet(
        WalletPlatform.NEON,
        this.targetNetwork
      )) === true
    )
  }

  private async connectWalletConnectN3(): Promise<boolean> {
    await this.showConnectionStep(ConnectWalletStep.WALLET_CONNECT)
    return (
      (await $.walletAdapter.connectN3Wallet(
        WalletPlatform.NEON,
        this.targetNetwork
      )) === true
    )
  }

  private async connectWalletConnectX(): Promise<boolean> {
    await this.showConnectionStep(ConnectWalletStep.WALLET_CONNECT)
    return (
      (await $.walletAdapter.connectXWallet(
        WalletPlatform.NEON,
        this.targetNetwork
      )) === true
    )
  }

  private async connectOneGateN3(): Promise<boolean> {
    if (this.isMobile && isOneGateInAppBrowser()) {
      return (
        (await $.walletAdapter.connectN3Wallet(
          WalletPlatform.ONEGATE,
          this.targetNetwork
        )) === true
      )
    }

    await this.showConnectionStep(ConnectWalletStep.ONEGATE_CONNECT)
    return false
  }

  private async connectOneGateX(): Promise<boolean> {
    await this.showConnectionStep(ConnectWalletStep.ONEGATE_CONNECT)
    return false
  }

  private async connectNeolineN3(): Promise<boolean> {
    if (this.isMobile) {
      if (isNeoLineInAppBrowser()) {
        return (
          (await $.walletAdapter.connectN3Wallet(
            WalletPlatform.NEOLINE,
            this.targetNetwork
          )) === true
        )
      }

      await this.showConnectionStep(ConnectWalletStep.NEOLINE_CONNECT)
      return false
    }

    const available = isNeoLineAvailableInBrowser('n3')
    const canUse = await $.walletAdapter.canUseN3Wallet(
      WalletPlatform.NEOLINE,
      this.targetNetwork
    )

    if (!canUse) {
      if (!available) {
        this.openNeolineDownloadPage()
        throw new Error('NeoLine extension not available')
      }

      $.toast.error('system.error.neolineNotReady')
      throw new Error('NeoLine wallet adapter is not ready')
    }

    return (
      (await $.walletAdapter.connectN3Wallet(
        WalletPlatform.NEOLINE,
        this.targetNetwork
      )) === true
    )
  }

  private async connectNeolineX(): Promise<boolean> {
    if (!isWalletPlatformEnabled(WalletPlatform.NEOLINE, 'neoX')) {
      return false
    }

    if (this.isMobile && !isNeoLineAvailableInBrowser('neoX')) {
      await this.showConnectionStep(ConnectWalletStep.NEOLINE_CONNECT)
      return false
    }

    const canUse = await $.walletAdapter.canUseXWallet(
      WalletPlatform.NEOLINE,
      this.targetNetwork
    )

    if (!canUse) {
      if (!isNeoLineAvailableInBrowser('neoX')) {
        this.openNeolineDownloadPage()
        throw new Error('NeoLine extension not available')
      }

      $.toast.error('system.error.neolineNotReady')
      throw new Error('NeoLine wallet adapter is not ready')
    }

    return (
      (await $.walletAdapter.connectXWallet(
        WalletPlatform.NEOLINE,
        this.targetNetwork
      )) === true
    )
  }
}
